import React from 'react';

function SelectDomain({ domains, selectedDomain, onChange }) {
  return (
    <select className="study-select" value={selectedDomain} onChange={onChange}>
      <option value="">— Choose —</option>
      <option value="all">✦ Study Everything</option>
      {domains.map((domain) => (
        <option key={domain.id} value={domain.id}>
          {domain.name}
        </option>
      ))}
    </select>
  );
}

export default SelectDomain;
